import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { ClipboardList, Plus, FolderOpen } from 'lucide-react';

const WorkProjects = () => {
  return (
    <div className="space-y-6" data-testid="work-projects">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Projeler</h1>
          <p className="text-gray-500">Dahil olduğunuz projeleri görüntüleyin</p>
        </div>
      </div>

      <Card>
        <CardContent className="p-8 text-center">
          <FolderOpen className="h-16 w-16 mx-auto mb-4 text-gray-200" />
          <h3 className="text-xl font-bold mb-2">Proje Bulunmuyor</h3>
          <p className="text-gray-500 mb-4">Dahil olduğunuz projeler burada listelenecek</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default WorkProjects;
